import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 w-screen overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "mt-2 text-center" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "text-sm text-gray-500" }
const _hoisted_6 = { class: "mt-3 grid grid-cols-1" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = { class: "text-sm text-gray-500" }
const _hoisted_10 = { class: "mt-2 flex justify-center" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "mt-5 sm:mt-6" }
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    as: "template",
    show: _ctx.open
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        class: "relative z-50",
        onClose: _ctx.close
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TransitionChild, {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogPanel, { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_DialogTitle, {
                          as: "h3",
                          class: "text-base font-semibold text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('share_gallery_modal.title')), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('share_gallery_modal.instructions')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("input", {
                            type: "text",
                            readonly: "",
                            name: "gallery-url",
                            id: "gallery-url",
                            class: "col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 sm:pr-9 sm:text-sm/6",
                            value: _ctx.url
                          }, null, 8, _hoisted_7),
                          (_openBlock(), _createElementBlock("svg", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyUrl && _ctx.copyUrl(...args)), ["prevent"])),
                            class: "cursor-pointer col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-gray-400 sm:size-4",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 18 18"
                          }, _cache[3] || (_cache[3] = [
                            _createElementVNode("g", {
                              transform: "translate(1 1)",
                              stroke: "#000",
                              "stroke-width": "1.5",
                              fill: "none",
                              "fill-rule": "evenodd",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("rect", {
                                width: "10.4",
                                height: "10.4",
                                x: "5.6",
                                y: "5.6",
                                rx: "1.6"
                              }),
                              _createElementVNode("path", { d: "M2.4 10.4h-.8A1.6 1.6 0 010 8.8V1.6A1.6 1.6 0 011.6 0h7.2a1.6 1.6 0 011.6 1.6v.8" })
                            ], -1)
                          ])))
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('share_gallery_modal.qr_instructions')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("img", {
                            class: "size-50",
                            src: _ctx.qrUrl,
                            alt: _ctx.$t(_ctx.name)
                          }, null, 8, _hoisted_11)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("a", {
                          href: _ctx.url,
                          target: "_blank",
                          class: "inline-flex w-full justify-center rounded-md bg-royal-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royal-blue-600"
                        }, _toDisplayString(_ctx.$t('share_gallery_modal.view_button')), 9, _hoisted_13),
                        _createElementVNode("button", {
                          type: "button",
                          class: "mt-2 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 cursor-pointer",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                        }, _toDisplayString(_ctx.$t('share_gallery_modal.close')), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["show"]))
}